import { TimestampDate } from '~/common/entities/Employees/EmployeeTypes';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { IdProvider, unwrap } from '../common/apiCommons';
import axios from 'axios';

export enum DateKey {
  DATE = 'DATE',
}

const DateQueries = {
  async getDate(date: IdProvider) {
    if (!date?.id) {
      return null;
    }
    const res = await axios.get<TimestampDate & { date: number }>(
      `/date/?date=${date.id}`,
    );
    return unwrap(res);
  },
};

const DateMutations = {};

const DateHooks = {
  useGetDate(
    idProvider: IdProvider,
    options?: UseQueryOptions<TimestampDate | null>,
  ) {
    return useQuery({
      queryKey: [DateKey.DATE],
      queryFn: () => DateQueries.getDate(idProvider),
      ...options,
    });
  },
};

const DateApi = {
  queries: DateQueries,
  mutations: DateMutations,
  hooks: DateHooks,
};

export default DateApi;
